import { Component, inject, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { D4CActions, Selectors } from "../store";
import { ActivatedRoute } from "@angular/router";
import { firstValueFrom } from "rxjs";
import { CommonModule } from "@angular/common";

@Component({
  imports: [CommonModule],
  selector: 'ca-privacy-and-cookie-policy',
  template: `
  @if (page$ |async; as page) {
  <div [outerHTML]="page.content"></div>
  <!-- {{page|json}} -->
  }
  `,
})
export class PrivacyAndCookiePolicyComponent implements OnInit {
  private store = inject(Store);
  page$ = this.store.select(Selectors.selectPrivacyAndCookiesPage);
  private route = inject(ActivatedRoute);

  ngOnInit(): void {
    firstValueFrom(this.route.data).then((res) => this.store.dispatch(D4CActions.LoadPrivacyAndCookies({ metaUrl: res['metaUrl'] })));
  }
}
